import React from 'react';
import { useNavigate } from 'react-router-dom';
import coins from '../assets/coins 1.png';
import settings__1__1 from '../assets/settings.png';
import faq_1 from '../assets/faq 1.png';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <div 
      className="flex-shrink-0 flex relative mt-0" 
      style={{ 
        width: 'clamp(830px, 86.46vw, 1660px)', 
        height: 'clamp(20px, 2.08vw, 40px)',
        borderTop: 'clamp(2px, 0.21vw, 4px) solid #8F0A0A'
      }}
    >
      <div 
        className="flex items-center absolute"
        style={{
          left: '0px',
          top: '0px',
          width: 'clamp(95px, 9.9vw, 190px)',
          height: 'clamp(20px, 2.08vw, 40px)',
          backgroundColor: '#004438',
          borderRight: 'clamp(2px, 0.21vw, 4px) solid #8F0A0A'
        }}
      >
        <span 
          className="text-white whitespace-nowrap"
          style={{
            marginLeft: 'clamp(8px, 0.83vw, 16px)',
            fontFamily: 'Keania One',
            fontWeight: 400,
            fontSize: 'clamp(7px, 0.73vw, 14px)',
            color: '#FFFFFF'
          }}
        >
          Account Status: Collector
        </span>
      </div>

      <div 
        className="flex items-center absolute"
        style={{
          right: '0px',
          top: '0px',
          height: 'clamp(20px, 2.08vw, 40px)'
        }}
      >
        <button 
          className="flex items-center text-white hover:text-white/70 transition-colors absolute"
          style={{
            right: 'clamp(18px, 1.98vw, 38px)',
            top: 'clamp(3.5px, 0.47vw, 9px)',
            gap: 'clamp(4px, 0.42vw, 8px)'
          }}
        >
          <img 
            src={faq_1} 
            alt="Support" 
            style={{
              width: 'clamp(9px, 0.94vw, 18px)',
              height: 'clamp(9px, 0.94vw, 18px)',
              opacity: 0.8
            }}
          />
          <span 
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: 'clamp(7px, 0.73vw, 14px)',
              color: 'rgba(255, 255, 255, 0.8)'
            }}
          >
            Support
          </span>
        </button>
        
        <div 
          style={{
            position: 'absolute',
            right: 'clamp(55px, 5.73vw, 110px)',
            top: '1px',
            width: 'clamp(0.5px, 0.05vw, 1px)',
            height: 'clamp(20px, 2.08vw, 40px)',
            backgroundColor: '#D9D9D9CC'
          }}
        />
        
        <button 
          onClick={() => navigate('/settings')}
          className="flex items-center text-white hover:text-white/70 transition-colors absolute"
          style={{
            right: 'clamp(74px, 7.49vw, 144px)',
            top: 'clamp(3.5px, 0.47vw, 9px)',
            gap: 'clamp(4px, 0.42vw, 8px)'
          }}
        >
          <img 
            src={settings__1__1} 
            alt="Settings" 
            style={{
              width: 'clamp(9px, 0.94vw, 18px)',
              height: 'clamp(9px, 0.94vw, 18px)',
              opacity: 0.8
            }}
          />
          <span 
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: 'clamp(7px, 0.73vw, 14px)',
              color: 'rgba(255, 255, 255, 0.8)'
            }}
          >
            Settings
          </span>
        </button>
        
        <div 
          style={{
            position: 'absolute',
            right: 'clamp(111px, 11.56vw, 222px)',
            top: '1px',
            width: 'clamp(0.5px, 0.05vw, 1px)',
            height: 'clamp(20px, 2.08vw, 40px)',
            backgroundColor: '#D9D9D9CC'
          }}
        />
        
        <button 
          className="flex items-center text-white hover:text-white/70 transition-colors absolute"
          style={{
            right: 'clamp(133px, 13.96vw, 268px)',
            top: 'clamp(3.5px, 0.47vw, 9px)',
            gap: 'clamp(4px, 0.42vw, 8px)'
          }}
        >
          <img 
            src={coins} 
            alt="Balance" 
            style={{
              paddingBottom: '2px',
              width: 'clamp(9px, 0.94vw, 18px)',
              height: 'clamp(9px, 0.94vw, 18px)',
              opacity: 0.8
            }}
          />
          <span 
            style={{
              fontFamily: 'Keania One',
              fontWeight: 400,
              fontSize: 'clamp(7px, 0.73vw, 14px)',
              color: 'rgba(255, 255, 255, 0.8)'
            }}
          >
            $158
          </span>
        </button>
        
        <div 
          style={{
            position: 'absolute',
            right: 'clamp(160px, 16.67vw, 320px)',
            top: '1px',
            width: 'clamp(0.5px, 0.05vw, 1px)',
            height: 'clamp(20px, 2.08vw, 40px)',
            backgroundColor: '#D9D9D9CC'
          }}
        />
      </div>
    </div>
  );
}

